<template>
<v-container>
  <v-layout row>
    <v-flex xs12>
      <v-card>
        <v-card-text>
          <v-container>
            <h2 class="mb-2">{{student.name}}</h2>
            <p>Added: {{student.added | formatDateTime}}</p>
            <form @submit.prevent="editStudent">
              <v-text-field
                name="fname"
                label="First name"
                id="fname"
                type="text"
                v-model.trim="fname"
                required>
              </v-text-field>

              <v-text-field
                name="lname"
                label="Last name"
                id="lname"
                type="text"
                v-model.trim="lname"
                required>
              </v-text-field>

              <v-text-field
                name="email"
                label="Email"
                id="email"
                type="email"
                v-model.trim="email"
                required>
              </v-text-field>

              <v-text-field
                name="pwd"
                label="Password"
                id="pwd"
                type="text"
                v-model.trim="password"
                disabled>
              </v-text-field>

              <v-layout row class="mt-4">
                <v-flex xs12>
                  <v-btn small type="submit" class="secondary">Save changes</v-btn>
                  <v-btn small class="ml-2" @click="$router.go(-1)">Cancel</v-btn>
                </v-flex>
              </v-layout>
            </form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</v-container>
</template>

<script>
export default {
  props: ['student'],
  data() {
    return {
      fname: this.student.fname,
      lname: this.student.lname,
      email: this.student.email,
      password: this.student.password
    };
  },
  methods: {
    editStudent() {
      let fullName = this.fname.trim() + " " + this.lname.trim();

      const editedStudent = {
        email: this.email,
        password: this.password,
        fname: this.fname,
        lname: this.lname,
        name: fullName,
        added: this.student.added,
        docId: this.student.docId,
        userId: this.student.userId,
        isActive: this.student.isActive
      };

      this.$store.dispatch("setType", "students");
      this.$store.dispatch("editStudent", editedStudent);
    }
  }
};
</script>

<style scoped>
.container {
  padding: 0px;
}
p {
  font-size: 12px;
  margin-bottom: 35px;
}

.v-btn {
  font-size: 0.9rem;
}
</style>